// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/instrument-steep-turns.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/instrument-steep-turns/instrument-steep-turns.js';
import g1 from '../lessons/aeronautics/instrument-steep-turns/turn-pitch-tendency.js';

mount([g0, g1]);
